export default {
  meta: {
    title: '踩点数据面板',
    url: '/car/footprintingpanel', // 埋点用，记录所属模块
    // eventId: 'c1f836bc-26e3-49e1-aaa0-298b0be9af28'
  },
};
